/**
 * 剩余时间
 * @param val 与当前时间戳的差值，单位为秒
 * @returns {string}
 */
export function remainTime (val) {
  let d, h, m, s;
  d = parseInt(val / (24 * 3600));
  h = parseInt((val - d * 24 * 3600) / 3600);
  m = parseInt((val - d * 24 * 3600 - h * 3600) / 60);  // 分钟
  s = val - d * 24 * 3600 - h * 3600 - m * 60;
  // res += d + '天' + parseInt(h) + '时' + parseInt(m) + '分' + s + '秒'
  return {
    d, h, m, s
    // d: d >= 10 ? d : '0' + d,
    // h: h >= 10 ? h : '0' + h,
    // m: m >= 10 ? m : '0' + m,
    // s: s >= 10 ? s : '0' + s
  };
}

/**
 * 格式化时间 传入date类型(单位)
 * @param date
 * @returns {{d: (*|number), h: any | number, y: number, m: string, minute: any | number, second: any | number}}
 */
export function formatDateObj (date) {
  date = new Date(date);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  return {
    y, m, d, h, minute, second
  };
}

/**
 * 文本框根据输入内容自适应高度
 * @param                {HTMLElement}        输入框元素
 * @param                {Number}                设置光标与输入框保持的距离(默认0)
 * @param                {Number}                设置最大高度(可选)
 */
export let autoTextarea = function (elem, extra, maxHeight) {
  extra = extra || 0;
  var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window,
    isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera'),
    addEvent = function (type, callback) {
      elem.addEventListener ?
        elem.addEventListener(type, callback, false) :
        elem.attachEvent('on' + type, callback);
    },
    getStyle = elem.currentStyle ? function (name) {
      var val = elem.currentStyle[name];

      if (name === 'height' && val.search(/px/i) !== 1) {
        var rect = elem.getBoundingClientRect();
        return rect.bottom - rect.top -
          parseFloat(getStyle('paddingTop')) -
          parseFloat(getStyle('paddingBottom')) + 'px';
      }
      ;

      return val;
    } : function (name) {
      return getComputedStyle(elem, null)[name];
    },
    minHeight = parseFloat(getStyle('height'));

  elem.style.resize = 'none';

  var change = function () {
    var scrollTop, height,
      padding = 0,
      style = elem.style;

    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;

    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
    }
    ;
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    elem.style.height = minHeight + 'px';
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding;
        style.overflowY = 'auto';
      } else {
        height = elem.scrollHeight - padding;
        style.overflowY = 'hidden';
      }
      ;
      style.height = height + extra + 'px';
      scrollTop += parseInt(style.height) - elem.currHeight;
      document.body.scrollTop = scrollTop;
      document.documentElement.scrollTop = scrollTop;
      elem.currHeight = parseInt(style.height);
    }
    ;
  };

  addEvent('propertychange', change);
  addEvent('input', change);
  addEvent('focus', change);
  change();
};

let top = 0;

export function stopBodyScroll (isFixed) {
  let bodyEl = document.body;
  if (isFixed) {
    top = window.scrollY;

    bodyEl.style.position = 'fixed';
    bodyEl.style.top = -top + 'px';
  } else {
    bodyEl.style.position = 'static';
    bodyEl.style.top = 'unset';

    window.scrollTo(0, top); // 回到原先的top
  }
}

/*
 * 获取url参数 返回一个对象
 * */
export function getRequestParameters () {
  let url = window.location.href;
  let obj = {};
  let index = url.lastIndexOf('?');
  if (index === -1) return {};
  url = url.substr(index + 1);
  let arr = url.split('&');
  for (let i = 0; i < arr.length; i++) {
    let b = arr[i].indexOf('=');
    obj[arr[i].substr(0, b).toLocaleLowerCase()] = arr[i].substr(b + 1); // 把地址栏参数名转成小写
  }
  return obj;
}
